module.exports = __webpack_public_path__ + "img/Arhive.ff186adf.svg";